import { useCallback, useRef } from 'react'

import { MAIN, STEM } from '@disco/constants/Nesting'
import { useShortlistUpload } from '@disco/services/upload/hooks'

import type { Track } from 'types/track'

export type NestingImportType = typeof MAIN | typeof STEM

type UploadFiles = ReturnType<typeof useShortlistUpload>['uploadFiles']

type NestingUpload = (
  files: Parameters<UploadFiles>[0],
  provider: Parameters<UploadFiles>[1],
  importType: NestingImportType,
  options?: Parameters<UploadFiles>[2],
) => Promise<void>

/**
 * Uploads files from the Manage nesting modal and reports which section
 * (versions or stems) the upload was started from.
 */
export const useNestingUpload = (
  onUploaded: (tracks: Track[], importType: NestingImportType) => void,
): { upload: NestingUpload; uploading: boolean } => {
  const importTypeRef = useRef<NestingImportType>(MAIN)
  const handleUploaded = useCallback(
    (tracks: Track[]) => onUploaded(tracks, importTypeRef.current),
    [onUploaded],
  )
  const { uploadFiles, uploading } = useShortlistUpload(handleUploaded)
  const upload = useCallback<NestingUpload>(
    (files, provider, importType, options) => {
      importTypeRef.current = importType
      return uploadFiles(files, provider, options)
    },
    [uploadFiles],
  )
  return { upload, uploading }
}
